/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ThreadStatus = core.serialization.enum_(["ready", "active", "error"]);
